import {defineStore} from 'pinia'
import {config} from "@/core/config";
import {useStylisationStore} from '@/store/stylisationStore'

interface GetTheLooks {
  [key: string]: string | number | Array<string> | boolean;
}

export const useGetTheLookStore = defineStore('getTheLookStore', {
  state: () => {
    return {
      getTheLookLoading: true,
      getTheLooks: [] as Array<GetTheLooks>,
      getTheLooksCategorized: [] as Array<GetTheLooks>
    }
  },
  getters: {
    getGetTheLookLoading(state) {
      return state.getTheLookLoading
    },
    getGetTheLooks(state) {
      return state.getTheLooks
    },
    getGetTheLooksCategorized(state) {
      return state.getTheLooksCategorized
    },
    getGetTheLooksWithoutFirst(state) {
      return state.getTheLooksCategorized.slice(1)
    },
    hasGetTheLooks(state) {
      return state.getTheLooks.length > 0 || state.getTheLooksCategorized.length > 0
    }
  },
  actions: {
    setGetTheLookLoading(value: boolean) {
      this.getTheLookLoading = value
    },
    setGetTheLooks(getTheLookSet: Array<GetTheLooks>) {
      this.getTheLooks = getTheLookSet
    },
    setGetTheLooksCategorized(getTheLookSet: Array<GetTheLooks>) {
      this.getTheLooksCategorized = getTheLookSet
    },
    
    async fetchGetTheLooks() {
      const stylisationStore = useStylisationStore()
      stylisationStore.getStylisationIdFromHash()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const stylisationId = window?._QONizer?.getProductId() || stylisationStore.getStylisationId
      if (!stylisationId) {
        this.setGetTheLookLoading(false)
        return
      }
      
      const {customerSymbol, stylistInstanceId, apiKey, apiHost} = config
      try {
        const response = await fetch(
          `https://${apiHost}/restapi/${customerSymbol}/stylist/${stylistInstanceId}/stylization/${stylisationId}/products`,
          {
            method: 'GET',
            headers: {
              'Api-key': apiKey,
            },
            credentials: 'include',
          }
        )
        
        if (response.ok) {
          const {getTheLooks} = await response.json()
          this.setGetTheLooks(getTheLooks)
          setTimeout(() => {
            this.setGetTheLookLoading(false)
          }, 300)
        }
      } catch (error) {
        this.setGetTheLookLoading(false)
      }
    },
    async fetchGetTheLooksCategorized() {
      const stylisationStore = useStylisationStore()
      stylisationStore.getStylisationIdFromHash()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const stylisationId = window?._QONizer?.getProductId() || stylisationStore.getStylisationId
      if (!stylisationId) {
        this.setGetTheLookLoading(false)
        return
      }
      
      const {customerSymbol, stylistInstanceId, apiKey, apiHost} = config
      try {
        const response = await fetch(
          `https://${apiHost}/restapi/${customerSymbol}/stylist/${stylistInstanceId}/stylization/${stylisationId}/categorizedProducts`,
          {
            method: 'GET',
            headers: {
              'Api-key': apiKey,
            },
            credentials: 'include',
          }
        )
        
        if (response.ok) {
          const {getTheLooks} = await response.json()
          this.setGetTheLookLoading(false)
          this.setGetTheLooksCategorized(getTheLooks)
        }
      } catch (error) {
        this.setGetTheLookLoading(false)
      }
    },
    
  }
})